import Helpers from "commons/helpers";
import Constants from "constants/index";
import MedkitService from "./medkit.service";
import { IRecordProject, IRecordProjectOrganization, IResponseGetPaged } from "commons/interfaces";

class ProjectService extends MedkitService {

    public getPaged = async (data: {
        searchText?: string;
        pageNumber?: number;
        pageSize?: number;
        orderby?: string;
    }): Promise<IResponseGetPaged<IRecordProject>> => {
        const query = Helpers.handleFormatParams(data);
        const result = await this.api.get({
            path: Constants.ApiPath.PROJECT.GET_PAGED + `${query ? "?" : ""}${query}`
        });
        return result.data.result;
    };

    public getDetail = async (id: string): Promise<IRecordProject> => {
        const result = await this.api.get({ path: Constants.ApiPath.PROJECT.DETAIL + `/${id}` });
        return result.data.result;
    };

    public create = async (data: {
        name: string,
        description: string,
    }) => {
        const result = await this.api.post({
            path: Constants.ApiPath.PROJECT.CREATE,
            data: data,
        });
        return result.data.result;
    };

    public update = async (data: {
        id: string,
        name: string,
        description: string,
    }) => {
        const result = await this.api.put({
            path: Constants.ApiPath.PROJECT.UPDATE,
            data: data,
        });
        return result.data.result;
    };

    public delete = async (id: string) => {
        const result = await this.api.delete({ path: Constants.ApiPath.PROJECT.DELETE + `/${id}` });
        return result.data.result;
    };


    public getPagedProjectOrganization = async (data: {
        projectId?: string;
        searchText?: string;
        pageNumber?: number;
        pageSize?: number;
        orderby?: string;
    }): Promise<IResponseGetPaged<IRecordProjectOrganization>> => {
        const query = Helpers.handleFormatParams(data);
        const result = await this.api.get({
            path: Constants.ApiPath.PROJECT.GET_PAGED_PROJECT_ORGANIZATION + `${query ? "?" : ""}${query}`
        });
        return result.data.result;
    };

    public createProjectOrganization = async (data: {
        projectId: string,
        organizationId: string,
    }) => {
        const result = await this.api.post({
            path: Constants.ApiPath.PROJECT.CREATE_PROJECT_ORGANIZATION,
            data: data,
        });
        return result.data.result;
    };

    public deleteProjectOrganization = async (data: {
        projectId: string,
        organizationId: string,
    }) => {
        const result = await this.api.put({
            path: Constants.ApiPath.PROJECT.DELETE_PROJECT_ORGANIZATION,
            data: data,
        });
        return result.data.result;
    };

};

export default ProjectService;